import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService } from '../services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-panneau-mail',
  templateUrl: './panneau-mail.component.html',
  styleUrls: ['./panneau-mail.component.css']
})
export class PanneauMailComponent implements OnInit {

  @Input() data;
  @Input() aUnSignature;
  @Input() isBtnPieceJointe;
  @Input() facture;
  @Input() showPJ;

  @Output() validerPanneauMail = new EventEmitter<any>();
  @Output() annulerPanneauMail = new EventEmitter<any>();
  impSelect: Boolean = false;

  listDocumentsFacture = [];
  listDocumentsBon = [];
  listDocumentsPJ = [];

  error = '';
  cheminSignature = '';

  constructor(public common: CommonService, private modalService: BsModalService) { }

  @ViewChild('msg') msg;
  @ViewChild('dialoguePieceJointe') dialoguePieceJointe;
  ngOnInit() {
    this.data.isEnvoiImageSignature = true;
    if (this.aUnSignature && this.data.signatureImage) {
      this.getLogo(this.data.signatureImage);
    }
  }

  annuler() {
      this.annulerPanneauMail.emit();
  }

  valider() {
    if (this.data.destinataire) {
      this.data.destinataire = this.common.replaceAll(this.data.destinataire, ';', ',');
    }

    if (this.data.cc) {
      this.data.cc = this.common.replaceAll(this.data.cc, ';', ',');
    }

    if (this.data.bcc) {
      this.data.bcc = this.common.replaceAll(this.data.bcc, ';', ',');
    }

    if(this.showPJ) {
        this.data['listDocumentsPJ'] = [];
        this.listDocumentsPJ.forEach(d => {
            if(d.nomFichierOriginal) {
                d['nomclass'] = 'FileObject';
                d['nomFichier'] = d['nomFichierOriginal']
                this.data['listDocumentsPJ'].push(d);
            }
        });
    }
    
    this.validerPanneauMail.emit(this.data);
  }

  getLogo(nomFichier) {
    if (nomFichier) {
      const param = {
        'servlet': 'DBGestionLogo',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 4
          },
          'TABLE': nomFichier
        }
      };

      this.common.post('', { param: param }).then(datas => {
        this.cheminSignature = datas.data.NOM_FICHIER && datas.data.NOM_FICHIER !== '' ? this.common.intercept(datas.data.NOM_FICHIER) : '';
        console.log('this.cheminSignature=' + this.cheminSignature);
      });
    }
  }

  handleBtnValiderPJ() {
     this.common.closeModal();
    this.data['listDocumentsFacture'] = [];
    this.listDocumentsFacture.forEach(ldf => {
      if (ldf['isChecked']) {
        this.data['listDocumentsFacture'].push({
          'typeParam': 'int',
          'valeur': ldf.id
        });
      }
    });

    this.data['listDocumentsBon'] = [];
    this.listDocumentsBon.forEach(ldb => {
      if (ldb['isChecked']) {
        this.data['listDocumentsBon'].push({
          'typeParam': 'int',
          'valeur': ldb.id
        });
      }
    });

   
  }

  handleBtnPieceJointe() {
    if (this.facture) {
      this.getBonFromClefFact(this.facture.id, this.facture['isAchat'] ? true : false).then(rvoid1 => {
        let clefTypeDocPieceEcorec = 2;
        if (this.facture.isAvoir) {
          clefTypeDocPieceEcorec = 5;
        } else if (this.facture.isAvoirAchat) {
          clefTypeDocPieceEcorec = 6;
        } else if (this.facture.isAchat) {
          clefTypeDocPieceEcorec = 4;
        }
        this.getDocs(this.facture.id, clefTypeDocPieceEcorec).then(rvoid2 => {
          // console.log(this.listDocumentsFacture);
          // console.log(this.listDocumentsBon);

          this.common.openModal(this.modalService, this.dialoguePieceJointe);
        });
      });
    }
  }

  // GestionFacture.java
  getBonFromClefFact(clefFact, isAchat) {
    const ctrl = this;
    const param = {
      'servlet': 'DBGetBonFact',
      'module': 'Ecofact',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': { 'typeParam': 'int', 'valeur': 1 },
        'CLEF_FACTURE': { 'typeParam': 'int', 'valeur': clefFact },
        'IS_ACHAT': { 'typeParam': 'boolean', 'valeur': isAchat },
      }
    };

    this.listDocumentsBon = []
    return this.common.post('', { param: param }).then(datas => {
      if (datas.data ) {
        if (datas.data && datas.data.length > 0) {
          datas.data.forEach(bon => {
            if (bon && bon['documents']) {
              this.listDocumentsBon = [...this.listDocumentsBon, ...(bon['documents'] || [])];
            }
          })
        }
      } else {
        ctrl.error = 'Un problème est survenu lors de la récupération des documents de bons de la facture';
        ctrl.common.openModal(ctrl.modalService, ctrl.msg);
      }
    });
  }


  // GestionDocPieceEcorec.java
  getDocs(clefPieceEcorec, clefTypeDocPieceEcorec) {
    const ctrl = this;
    const param = {
      'servlet': 'DBGestionDocPieceEcorec',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': { 'typeParam': 'int', 'valeur': 1 },
        'CLEF_PIECE_ECOREC': { 'typeParam': 'int', 'valeur': clefPieceEcorec },
        'CLEF_TYPE_DOC_PIECE_ECOREC': { 'typeParam': 'int', 'valeur': clefTypeDocPieceEcorec },
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (datas.data) {
        this.listDocumentsFacture = datas.data || [];
      } else {
        ctrl.error = 'Un problème est survenu lors de la récupération des documents de la facture';
        ctrl.common.openModal(ctrl.modalService, ctrl.msg);
      }
    });
  }

  openDocFactNewTab(row) {
    const param = {
      'servlet': 'DBGestionDocPieceEcorec',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'pathImpression': 'Recylog/tmp/',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        },
        'NOM_FICHIER': row.nomFichier,
        'USER': {
          'typeParam': 'int',
          'valeur': this.common.user[0]
        }
      }
    };

    this.common.post('', { param: param }).then(datas => {
      this.common.openFile(datas.data[0]);
    });
  }

  openDocBonNewTab(row) {
    const param = {
      'servlet': 'DBImprimerDocuments',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'pathImpression': 'Recylog/tmp/',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'ID_DOC_BON': {
          'typeParam': 'int',
          'valeur': row.id
        },
        'IS_DOC_LOCATION': {
          'typeParam': 'boolean',
          'valeur': false
        }
      }
    };

    this.common.post('', { param: param }).then(datas => {
      this.common.openFile(datas.data[0]);
    });
  }
  
  addLigne() {
    this.listDocumentsPJ = this.listDocumentsPJ || [];
    this.listDocumentsPJ.push({});
    this.listDocumentsPJ = [...this.listDocumentsPJ];
  }

  deleteLigne(row) {
    const temp = this.listDocumentsPJ.filter(elt => elt !== row);
    this.listDocumentsPJ = temp;
  }  
  
  getNameFile(event, item) {
    const file = event.target.files[0];
        
    if(!this.common.checkExtFichierImgEtTexte(file.name)) {
      this.error = this.common.msgErreurExtensionFichier;
      this.common.openModal(this.modalService, this.msg);    
      this.deleteLigne(item);
      return;
    }                    
    
    item.nomFichierOriginal = file.name;
    const fileReader = new FileReader();
    const ctrl = this;
    fileReader.onload = function () {
      const base64 = (<string>fileReader.result).split(',');
      item.contentBase64 = base64[1];
    };
    fileReader.readAsDataURL(file);
  }  
}
